import {
  LelyTextColorLight,
  LelyFontFamily,
  LelyFontSize,
  LelyFontWeight,
  LelyLineHeight,
} from '@lely/tokens/enums';
import { TypographyVariantsOptions } from '@mui/material';

export const text = {
  xl: {
    fontSize: LelyFontSize.XL,
    lineHeight: LelyLineHeight._2XL,
  },
  lg: {
    fontSize: LelyFontSize.LG,
    lineHeight: LelyLineHeight.XL,
  },
  base: {
    fontSize: LelyFontSize.BASE,
    lineHeight: LelyLineHeight.XL,
  },
  md: {
    fontSize: LelyFontSize.MD,
    lineHeight: LelyLineHeight.LG,
  },
  xs: {
    fontSize: LelyFontSize.SM,
    lineHeight: LelyLineHeight.BASE,
  },

  // Custom error variant
  error: {
    fontSize: LelyFontSize.SM,
    lineHeight: LelyLineHeight.BASE,
    color: LelyTextColorLight.ERROR,
  },
} as const;

export type LelyTypographyVariants = typeof text;
export type LelyTypographyVariant = keyof typeof text;
export type LelyVariantOverrides = Record<LelyTypographyVariant, true>;

const lelyTypography: TypographyVariantsOptions = {
  fontFamily: LelyFontFamily.UBUNTU,
  fontWeightLight: LelyFontWeight.LIGHT,
  fontWeightRegular: LelyFontWeight.REGULAR,
  fontWeightMedium: LelyFontWeight.MEDIUM,
  fontWeightBold: LelyFontWeight.BOLD,
  allVariants: {
    color: LelyTextColorLight.DEFAULT,
    fontWeight: LelyFontWeight.REGULAR,
    letterSpacing: 'inherit',
  },

  h1: {
    fontSize: LelyFontSize._6XL,
    lineHeight: LelyLineHeight._6XL,
  },
  h2: {
    fontSize: LelyFontSize._5XL,
    lineHeight: LelyLineHeight._5XL,
  },
  h3: {
    fontSize: LelyFontSize._4XL,
    lineHeight: LelyLineHeight._4XL,
  },
  h4: {
    fontSize: LelyFontSize._3XL,
    lineHeight: LelyLineHeight._3XL,
  },
  h5: {
    fontSize: LelyFontSize._2XL,
    lineHeight: LelyLineHeight._2XL,
  },
  h6: {
    fontSize: LelyFontSize.XL,
    lineHeight: LelyLineHeight.XL,
  },

  // typography variants based on zero height
  ...text,

  // Default mui typography, we need to think if we are going to use them or the custom ones matching the zero height spec
  body1: {
    fontSize: LelyFontSize.BASE,
    lineHeight: LelyLineHeight.XL,
  },
  body2: {
    fontSize: LelyFontSize.MD,
    lineHeight: LelyLineHeight.LG,
  },
  subtitle1: {
    fontSize: LelyFontSize.SM,
    lineHeight: LelyLineHeight.BASE,
  },
  caption: {
    fontSize: LelyFontSize.SM,
  },
  button: {
    fontSize: LelyFontSize.SM,
    lineHeight: LelyLineHeight.BASE,
    textTransform: 'none',
  },
};

export default lelyTypography;
